var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"color":"transparent","id":"content-page"}},[_vm._t("content"),_c('content-footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }